<template>
  <div>
    <v-container class="profile-container white">
      <v-card class="profile-card">
        <v-card-title class="profile-title">
          <v-icon large left>mdi-account-circle</v-icon>
          Mi Perfil
          <v-spacer></v-spacer>
          
          <!-- Estados Aprobado y Rechazado usan v-chip para mantener colores -->
<v-chip 
            v-if="isApproved"
            color="success"
            outlined
            small
            class="verification-chip verification-chip--approved"
          >
            <v-icon left small color="success">mdi-check-circle</v-icon>
            Verificado
          </v-chip>
          
          <v-chip 
            v-else-if="isRejected"
            color="error"
            outlined
            small
            class="verification-chip verification-chip--rejected"
          >
            <v-icon left small color="error">mdi-close-circle</v-icon>
            Verificación Rechazada
          </v-chip>
          
          <!-- Estados intermedios siguen usando v-btn -->
          <v-btn 
            v-else
            :color="getVerificationButtonProps().color"
            :loading="getVerificationButtonProps().loading || verificationLoading"
            :class="getVerificationButtonProps().textColor"
            small 
            @click="handleVerificationClick"
            class="verification-btn"
            outlined
          >
            <v-icon left small>{{ getVerificationButtonProps().icon }}</v-icon>
            {{ getVerificationButtonProps().text }}
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Nombre</v-list-item-title>
                    <v-list-item-subtitle>{{ user.name }} <VerificationBadge /> </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Email</v-list-item-title>
                    <v-list-item-subtitle>{{
                      user.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-calendar</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Fecha de Ingreso</v-list-item-title>
                    <v-list-item-subtitle>{{
                      formatDate(user.joinDate)
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" md="6">
              <v-list>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-city</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Ciudad</v-list-item-title>
                    <v-list-item-subtitle>{{ user.city }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Teléfono</v-list-item-title>
                    <v-list-item-subtitle>{{
                      user.phone
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-card-account-details</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>DNI</v-list-item-title>
                    <v-list-item-subtitle>{{ user.dni }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>mdi-account-star</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Categoría</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-chip
                        small
                        :color="getCategoryColor(user.category)"
                        dark
                      >
                        {{ user.category }}
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="exclusion-section">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon left color="error">mdi-alert-circle</v-icon>
                <span class="error--text">Solicitud de Autoexclusión</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-alert type="warning" outlined>
                  Al solicitar la autoexclusión, tu cuenta será desactivada
                  permanentemente. Esta acción no se puede deshacer.
                </v-alert>

                <v-form v-model="valid" @submit.prevent="requestExclusion">
                  <v-select
                    v-model="exclusionReason"
                    :items="exclusionReasons"
                    label="Motivo de autoexclusión"
                    required
                    outlined
                  ></v-select>
                  <v-textarea
                    v-model="additionalComments"
                    label="Comentarios adicionales"
                    outlined
                    rows="3"
                  ></v-textarea>
                  <v-checkbox
                    v-model="confirmExclusion"
                    label="Confirmo que deseo eliminar mi cuenta permanentemente"
                    required
                  ></v-checkbox>
                  <v-btn
                    type="submit"
                    color="error"
                    :disabled="!valid || !confirmExclusion"
                    :loading="loading"
                  >
                    <v-icon left>mdi-account-remove</v-icon>
                    Solicitar Eliminación de Cuenta
                  </v-btn>
                </v-form>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-actions>
      </v-card>

      <!-- Diálogo de Confirmación de Autoexclusión -->
      <v-dialog v-model="confirmDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Confirmar Autoexclusión</v-card-title>
          <v-card-text>
            ¿Estás seguro que deseas eliminar tu cuenta permanentemente? Esta
            acción no se puede deshacer y perderás acceso a todos tus datos.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmDialog = false">Cancelar</v-btn>
            <v-btn color="error" @click="confirmExclusionAction"
              >Confirmar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Componente de Verificación de Identidad -->
      <VerifyIdentity
        :show="showVerifyDialog"
        @close="showVerifyDialog = false"
        @verification-success="handleVerificationSuccess"
        @verification-error="handleVerificationError"
      />

      <!-- Modal con iframe para la verificación -->
      <v-dialog v-model="showVerifyIframe" max-width="900" persistent>
        <v-card>
          <v-card-title>
            <v-icon left color="primary">mdi-shield-account</v-icon>
            Verificación de Identidad
            <v-spacer></v-spacer>
            <v-btn icon @click="showVerifyIframe = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 600px; padding: 0;">
            <iframe
              v-if="verifyIframeUrl"
              :src="verifyIframeUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: none; min-height: 600px;"
            ></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-alert v-if="message" :type="messageType" outlined class="mt-4">
        {{ message }}
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import VerifyIdentity from "../../components/VerifyIdentity.vue";
import VerificationBadge from "../../components/VerificationBadge.vue";

export default {
  components: {
    VerifyIdentity,
    VerificationBadge
  },
  data() {
    return {
      user: {
        name: this.$store.state.nombre,
        email: this.$store.state.emailU,
        joinDate: this.$store.state.fechaIngreso,
        city: this.$store.state.pais_user,
        phone: this.$store.state.tlfU,
        dni: this.$store.state.cedula,
        category: "D",
      },
      valid: false,
      loading: false,
      confirmDialog: false,
      confirmExclusion: false,
      exclusionReason: null,
      additionalComments: "",
      exclusionReasons: [
        "Problemas con el juego",
        "Motivos personales",
        "Problemas financieros",
        "Otros",
      ],
      message: "",
      messageType: "",
      // Verificación de identidad
      showVerifyDialog: false,
      showVerifyIframe: false,
      verifyIframeUrl: null,
      // Nuevos datos para manejo de verificación
      verificationStatus: null,
      isVerified: false,
      isApproved: false,
      isRejected: false,
      verificationLoading: false,
    };
  },
  mounted(){
    this.handleVerificatiCheck();
    this.checkVerificationStatus(); // Consultar estado al cargar
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString("es-AR");
    },
    getCategoryColor(category) {
      const colors = { D: "grey", C: "blue", B: "purple", A: "amber" };
      return colors[category] || "green";
    },
    requestExclusion() {
      this.confirmDialog = true;
    },
    async confirmExclusionAction() {
      try {
        this.loading = true;
        const payload = {
          name: this.user.name,
          email: this.user.email,
          joinDate: this.user.joinDate,
          city: this.user.city,
          phone: this.user.phone,
          dni: this.user.dni,
          category: this.user.category,
          exclusionReason: this.exclusionReason,
          additionalComments: this.additionalComments,
        };

        const endpoint = "/autoexclusion";
        const response = await axios.post(endpoint, payload);

        this.loading = false;
        this.confirmDialog = false;

        if (response.data.success) {
          this.message =
            response.data.message || "Tu solicitud fue enviada exitosamente.";
          this.messageType = "success";
        } else {
          this.message = response.data.message || "Error en la solicitud.";
          this.messageType = "error";
        }
      } catch (error) {
        this.loading = false;
        this.confirmDialog = false;
        console.error(error);
        this.message =
          "Hubo un error al enviar tu solicitud. Intenta nuevamente.";
        this.messageType = "error";
      }
    },
    
    // Métodos para manejo de verificación
    async checkVerificationStatus() {
      try {
        this.verificationLoading = true;
        const response = await axios.get('/verification/status');
        const { verified, approved, rejected, estado } = response.data;
        
        this.verificationStatus = estado;
        this.isVerified = verified;
        this.isApproved = approved;
        this.isRejected = rejected;
        
      } catch (error) {
        console.error('Error checking verification status:', error);
        // Si hay error, asumimos que no está verificado
        this.verificationStatus = 'Error';
        this.isVerified = false;
        this.isApproved = false;
        this.isRejected = false;
      } finally {
        this.verificationLoading = false;
      }
    },
    
    getVerificationButtonProps() {
      // Solo para estados intermedios (ya que Aprobado/Rechazado usan v-chip)
      if (this.verificationStatus === 'En Proceso') {
        return {
          color: 'white',
          icon: 'mdi-sync',
          text: 'Verificación en Curso',
          loading: false,
          textColor: 'grey--text text--darken-3'
        };
      } else if (this.verificationStatus === 'Iniciado') {
        return {
          color: 'white',
          icon: 'mdi-restart',
          text: 'Continuar Verificación',
          loading: false,
          textColor: 'grey--text text--darken-3'
        };
      } else {
        // Pendiente, No iniciado, o cualquier otro estado
        return {
          color: 'white',
          icon: 'mdi-shield-account',
          text: 'Verificar Identidad',
          loading: false,
          textColor: 'grey--text text--darken-3'
        };
      }
    },
    
    handleVerificationClick() {
      // ✅ Solo NO puede hacer clic si está Aprobado (pero eso ya se maneja con v-chip)
      // Todos los otros estados (Rechazado, En Proceso, Iniciado, Pendiente) pueden reiniciar
      
      if (this.isRejected) {
        this.message = "Tu verificación anterior fue rechazada. Puedes intentar nuevamente.";
        this.messageType = "warning";
      } else if (this.verificationStatus === 'En Proceso') {
        this.message = "Tienes una verificación en curso. Al reiniciar comenzarás un nuevo proceso.";
        this.messageType = "info";
      } else if (this.verificationStatus === 'Iniciado') {
        this.message = "Puedes continuar o reiniciar tu proceso de verificación.";
        this.messageType = "info";
      } else {
        this.message = "Iniciando proceso de verificación de identidad.";
        this.messageType = "info";
      }
      
      this.showVerifyDialog = true;
    },

    handleVerificationSuccess(data) {
      localStorage.setItem('verifyId', data.verifyId);
      const cleanUrl = data.url.replace(/\\\//g, '/');
      window.open(cleanUrl, "_self");
      this.message = "Se abrió la verificación de identidad en una nueva pestaña.";
      this.messageType = "info";
      
      // Iniciar polling para verificar el estado
      this.startVerificationPolling();
    },
    
    startVerificationPolling() {
      // Verificar el estado cada 5 segundos por 2 minutos
      let attempts = 0;
      const maxAttempts = 24; // 2 minutos (24 * 5 segundos)
      
      const pollInterval = setInterval(async () => {
        attempts++;
        await this.checkVerificationStatus();
        
        // Si está completado (aprobado o rechazado) o excedió intentos
        if (this.isVerified || attempts >= maxAttempts) {
          clearInterval(pollInterval);
          
          if (this.isApproved) {
            this.message = "¡Verificación completada exitosamente!";
            this.messageType = "success";
          } else if (this.isRejected) {
            this.message = "Verificación rechazada. Puedes intentar nuevamente.";
            this.messageType = "error";
          }
        }
      }, 5000); // 5 segundos
    },
    
    handleVerificationError(data) {
      this.message = data.message;
      this.messageType = "error";
    },
    
    handleVerificatiCheck() {
      if(this.$route.query.verify === 'yes') {
        // El usuario regresó del proceso de verificación
        this.checkVerificationStatus();
        
        // Mostrar mensaje según el estado
        setTimeout(() => {
          if (this.isApproved) {
            this.message = "¡Verificación completada exitosamente!";
            this.messageType = "success";
          } else if (this.isRejected) {
            this.message = "Verificación rechazada. Revisa los datos e intenta nuevamente.";
            this.messageType = "warning";
          }
        }, 1000);
      }
    },
  },
};
</script>

<style scoped>
.profile-container {
  max-width: 900px;
  margin-top: 30px;
  background-color: white !important;
  padding: 24px;
}
.profile-card {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background-color: white;
}
.profile-title {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 500;
  padding: 20px;
  color: #333;
  background-color: white;
}
.exclusion-section {
  padding: 0 16px 16px;
  background-color: white;
}
.v-list {
  background-color: white;
}
.v-list-item {
  padding-left: 0;
  background-color: white;
}
.v-list-item__icon {
  margin-right: 16px;
}
.v-list-item__title {
  font-weight: 500;
  color: #555;
}
.v-list-item__subtitle {
  font-size: 1rem;
  color: #333;
}
.v-expansion-panel-header {
  font-weight: 500;
  background-color: #f5f5f5;
}
.v-expansion-panel-content {
  background-color: white;
}
.v-card {
  background-color: white;
}
.v-card-text {
  background-color: white;
}
.verification-btn {
  transition: all 0.3s ease;
  font-weight: 500;
  border: 1px solid #e0e0e0 !important;
}
.verification-chip {
  font-weight: 500;
  cursor: default;
}
</style>